import React, { Component, Fragment } from 'react';
import AlertsMenu from './menu/AlertsMenu';
import AlertsListContainer from './list/AlertsListContainer';
import { getRuleCategoryUrl } from '../../../services/RuleCategory';
import TransparentButton from '../../../shared/button/transparent-button/TransparentButton';
import {
    redirectTo,
    redirectToDismissedAlerts
} from '../../../routing/redirectService';
import { PageActionsRow } from '../../../shared/headers/PageActionsRow';
import { connect } from 'react-redux';
import { exportCsvAlerts } from '../export-csv/redux/actions';
import { getAlertsState } from './list/redux/selectors';
import * as _ from 'lodash';
import { getExportCsvLoading } from '../export-csv/redux/selector';
import {
    getCanUpdateRules,
    isSandboxSelected
} from '../../../jurisdiction/redux/selectors';

class AlertsContainer extends Component {
    constructor(props) {
        super(props);
        redirectToDismissedAlerts.bind(this);
    }

    onClickModifyRules = () => {
        let ruleCategoryUrl = getRuleCategoryUrl(this.props.ruleCategory);
        redirectTo('/modify-rules/' + ruleCategoryUrl, {
            ruleCategory: this.props.ruleCategory
        });
    };

    handleExportCsv = () => {
        const { alertsState, exportCsvAlerts } = this.props;
        const {
            ruleCategory,
            dismissed,
            pagination,
            sort,
            username,
            jurisdictionCode,
            brandId,
            ruleType,
            alertLevel
        } = alertsState;

        _.isFunction(exportCsvAlerts) &&
            exportCsvAlerts({
                ruleCategory,
                dismissed,
                pagination,
                sort,
                username,
                jurisdictionCode,
                brandId,
                ruleType,
                alertLevel
            });
    };

    renderModifyRulesButton = () => (
        <Fragment>
            <TransparentButton
                disabled={this.props.loading || this.props.sandboxSelected}
                onClick={this.handleExportCsv}
            >
                <i className={'material-icons'}>save</i>
                {this.props.loading ? 'Exporting...' : 'Download CSV'}
            </TransparentButton>
            {this.props.canUpdateRules && (
                <TransparentButton onClick={this.onClickModifyRules.bind(this)}>
                    <i className={'material-icons'}>tune</i>
                    Modify Rules
                </TransparentButton>
            )}
        </Fragment>
    );

    render() {
        const { ruleCategory } = this.props;

        return (
            <span className="container">
                <PageActionsRow leftContent={<AlertsMenu />}>
                    {this.renderModifyRulesButton()}
                </PageActionsRow>

                <AlertsListContainer ruleCategory={ruleCategory} />
            </span>
        );
    }
}

const mapStateToProps = (state, { ruleCategory }) => {
    return {
        loading: getExportCsvLoading(state),
        alertsState: getAlertsState(state),
        // The alerts of a sandbox cannot be exported
        sandboxSelected: isSandboxSelected(state),
        // The button follows the page it opens: the rules of a jurisdiction need the permission for every brand of it
        canUpdateRules: getCanUpdateRules(state, ruleCategory)
    };
};
const mapDispatchToProps = dispatch => ({
    exportCsvAlerts: params => dispatch(exportCsvAlerts(params))
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertsContainer);
